import React, { useState, useEffect } from 'react';
import Layout from './SenderForm/Layout/Layout';
import Request from './SenderForm/Workspace/Request/RequestPanel';
import Response from './SenderForm/Workspace/Response/ResponsePanel';
import ResponseCondition from './SenderForm/ResponseCondition';
import MessageIdForm from './SenderForm/MessageIdForm';

const SenderForm = ({ sender }) => {
  const [senderName, setSenderName] = useState(sender ? sender.name : '');
  const [testPhoneNumber, setTestPhoneNumber] = useState(sender ? sender.test_phone : '');
  const [testMessage, setTestMessage] = useState(sender ? sender.test_message : '');
  const [rateLimit, setRateLimit] = useState(sender && sender.rate_limit != null ? sender.rate_limit : '');
  const [unlimitedRate, setUnlimitedRate] = useState(Boolean(sender && sender.unlimited_rate));
  const [smsCost, setSmsCost] = useState(sender && sender.sms_cost != null ? sender.sms_cost : '');

  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState('');
  const [formData, setFormData] = useState({
    request: {}, // Данные из компонента Request
    responseCondition: {}, // Данные из компонента ResponseCondition
    messageIdForm: {} // Данные из компонента MessageIdForm
    // Добавьте другие необходимые поля здесь
  });

  useEffect(() => {
    // Инициализация formData при монтировании компонента
    setFormData({
      request: {
        url: sender ? sender.url : '',
        headers: sender ? sender.headers : [],
        reqMethod: sender ? sender.request_type : '',
        requestBody: sender ? JSON.stringify(sender.request_body) : '',
        queryParams: sender ? sender.query_params : [],
      },
      responseCondition: sender ? sender.search_conditions.responseCondition : {},
      messageIdForm: sender ? sender.message_id_find : {},
      // Добавьте другие необходимые поля здесь
    });
  }, [sender]);

  const handleSaveSender = async () => {
    setSaveError('');

    if (!senderName.trim()) {
      setSaveError('Sender name is required.');
      return;
    }

    const rawBody = (formData.request.requestBody || '').trim();
    let requestBody;
    try {
      requestBody = rawBody === '' ? {} : JSON.parse(rawBody);
    } catch (e) {
      setSaveError(`Request body is not valid JSON: ${e.message}`);
      return;
    }

    const isUpdate = sender && sender.id; // Проверяем, существует ли 'id' у 'sender'
    const endpoint = isUpdate ? `/senders/${sender.id}` : "/senders";
    const method = isUpdate ? 'PUT' : 'POST';

    const data = {
      name: senderName, // Это пример, замените на реальные данные
      url: formData.request.url,
      headers: formData.request.headers,
      request_type: formData.request.reqMethod,
      request_body: requestBody,
      query_params: formData.request.queryParams,
      search_conditions: {
        responseCondition: formData.responseCondition
      },
      message_id_find: {
        // Данные из компонента MessageIdForm
        data_type: formData.messageIdForm.dataType,
        selector: formData.messageIdForm.selector
      },
      // Добавьте другие необходимые поля здесь
      test_phone: testPhoneNumber,
      test_message: testMessage,
      unlimited_rate: unlimitedRate,
      rate_limit: rateLimit === '' || rateLimit == null ? null : parseInt(rateLimit, 10),
      sms_cost: smsCost === '' || smsCost == null ? null : parseFloat(smsCost)
    };

    setSaving(true);
    try {
      const csrfToken = document.querySelector('[name=csrf-token]').content;
      const response = await fetch(endpoint, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        window.location.href = '/senders'; // Редирект на senders#index
      } else {
        let message = `Failed to save sender (${response.status})`;
        try {
          const err = await response.json();
          if (err && err.errors) {
            message = Array.isArray(err.errors) ? err.errors.join(', ') : String(err.errors);
          } else if (err && err.error) {
            message = err.error;
          }
        } catch (_) {
        }
        setSaveError(message);
      }
    } catch (error) {
      setSaveError(`Network error: ${error.message}`);
    } finally {
      setSaving(false);
    }
  };

  // Функция для обновления данных из дочерних компонентов
  const updateFormData = (key, data) => {
    console.log('updateFormData:', key, data);
    setFormData((prev) => ({ ...prev, [key]: data }));
  };

  return (
    <>
        <Layout>
          <section className="sender-settings" aria-label="Sender settings">
            <div className="sender-settings__field sender-settings__name">
              <label htmlFor="senderName">Sender name</label>
              <input id="senderName" type="text" value={senderName}
                onChange={(e) => setSenderName(e.target.value)} placeholder="Enter Sender Name" />
            </div>
            <div className="sender-settings__field">
              <label htmlFor="rateLimit">Rate limit (requests / sec)</label>
              <input id="rateLimit" type="number" min="1" disabled={unlimitedRate}
                value={unlimitedRate ? '' : rateLimit}
                onChange={(e) => setRateLimit(e.target.value)}
                placeholder={unlimitedRate ? 'No provider limit' : 'Service default'}
                aria-describedby="senderRateHelp" />
              <label className="sender-settings__toggle">
                <input type="checkbox" checked={unlimitedRate}
                  onChange={(e) => setUnlimitedRate(e.target.checked)} />
                No provider rate limit
              </label>
              <p id="senderRateHelp" className="sender-settings__help">
                {unlimitedRate ? 'Limited by service capacity.' : 'Shared across campaigns. Blank uses the service default.'}
              </p>
            </div>
            <div className="sender-settings__field">
              <label htmlFor="smsCost">Price per SMS ($)</label>
              <input id="smsCost" type="number" min="0" step="0.0001" value={smsCost}
                onChange={(e) => setSmsCost(e.target.value)} placeholder="e.g. 0.02" />
              <p className="sender-settings__help">Used for CPC calculation.</p>
            </div>
            <div className="sender-settings__actions">
              <button className="sender-settings__save" onClick={handleSaveSender} disabled={saving}>
                {saving ? 'Saving…' : 'Save Sender'}
              </button>
            </div>
          </section>
          {saveError && (
            <p className="mb-4 text-sm text-red-600 whitespace-pre-line">
              {saveError}
            </p>
          )}
          <Request
            setResponse={setResponse}
            setLoading={setLoading}
            senderData={sender}
            updateFormData={data => updateFormData('request', data)}
            testPhoneNumber={testPhoneNumber}
            setTestPhoneNumber={setTestPhoneNumber}
            testMessage={testMessage}
            setTestMessage={setTestMessage}
          />
          <Response response={response} loading={loading} />
          <ResponseCondition
            response={response}
            updateFormData={data => updateFormData('responseCondition', data)}
            senderData={sender}
          />
          <MessageIdForm
            response={response}
            updateFormData={data => updateFormData('messageIdForm', data)}
            senderData={sender}
          />
        </Layout>
    </>
  );
};

export default SenderForm;
